/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum VitalSignListAliases {
  AUTOC_VITAL_SIGN_NM_ATTR = 'autoc-vital-sign-nm-attr',
  BUTTON_ADD_VITAL_SIGNAL = 'button-add-vital-signal',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  DATE_PICKER_END_DATE = 'date-picker-end-date',
  DATE_PICKER_START_DATE = 'date-picker-start-date',
  DECK_VITAL_SIGN = 'deck-vital-sign',
  FETCH_VITAL_SIGN = 'fetch-vital-sign',
  FETCH_VITAL_SIGNS_ITEM = 'fetch-vital-signs-item',
  FILTER_FIELD_DATE_END = 'filter-field-date-end',
  FILTER_FIELD_DATE_START = 'filter-field-date-start',
  FILTER_FIELD_VITAL_SIGNS_ITEM = 'filter-field-vital-signs-item',
  FILTER_VITAL_SIGNS = 'filter-vital-signs',
  FILTERED_LIST_0 = 'filtered-list-0',
  GLOBAL_ACTIONS_0 = 'global-actions-0',
  LAYOUT_VITAL_SIGN_LIST = 'layout-vital-sign-list',
  LEGENDS_VITAL_SIGN = 'legends-vital-sign',
  MAPPER_VITAL_SIGNS_ITEM = 'mapper-vital-signs-item',
  PANEL_0 = 'panel-0',
  PANEL_1 = 'panel-1',
  PANEL_GLOBAL_ACTIONS = 'panel-global-actions',
  TEXT_VITAL_SIGNS_ITEM = 'text-vital-signs-item',
  VITAL_SIGN_CARD = 'vital-sign-card',
}
export { VitalSignListAliases };
